import { render, staticRenderFns } from "./BlockFooter.vue?vue&type=template&id=24ea4954"
import script from "./BlockFooter.vue?vue&type=script&lang=js"
export * from "./BlockFooter.vue?vue&type=script&lang=js"
import style0 from "./BlockFooter.vue?vue&type=style&index=0&id=24ea4954&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports